angular.module('unica_auth.auth_controllers')

.controller('NamController', function( $location,
	$rootScope, $scope, $state, LoginService ) {

	const token = $location.search().token;
	if ( !token ) {
		$scope.showErrorMsg('Token mancante!', 'Impossibile procedere con il login.');
		$state.go('app.auth_error');
		return;
	}

	$scope.showLoader();

	LoginService
		.checkNAM( token )
		.then(function(data) {
			$scope.hideLoader();

			if ( !data ) {
				$scope.showErrorMsg('Login fallito!', 'Impossibile effettuare il login.');
				$state.go('app.auth_error');
				return;
			}

			$scope.showSuccessMsg('Login effettuato con successo!', '');
			$rootScope.setCurrentUser( data );
			$rootScope.isAuthorized = true;
			$state.go('app.dashboard');
		});

});